/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindProductionSiteRequestByUserForNonBrandQueryResponse } from "../types/FindProductionSiteRequestByUserForNonBrand.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductionSiteRequestByUserForNonBrandQueryKey = () =>
  [
    {
      url: "/v1/production-site-request/find-production-site-request-by-user-non-brand",
    },
  ] as const

export type FindProductionSiteRequestByUserForNonBrandQueryKey = ReturnType<
  typeof findProductionSiteRequestByUserForNonBrandQueryKey
>

/**
 * @summary Find production site request by user for non-brand
 * {@link /v1/production-site-request/find-production-site-request-by-user-non-brand}
 */
export async function findProductionSiteRequestByUserForNonBrand(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductionSiteRequestByUserForNonBrandQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/production-site-request/find-production-site-request-by-user-non-brand`,
    ...requestConfig,
  })
  return res
}

export function findProductionSiteRequestByUserForNonBrandQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductionSiteRequestByUserForNonBrandQueryKey()
  return queryOptions<
    ResponseConfig<FindProductionSiteRequestByUserForNonBrandQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductionSiteRequestByUserForNonBrandQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductionSiteRequestByUserForNonBrand({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find production site request by user for non-brand
 * {@link /v1/production-site-request/find-production-site-request-by-user-non-brand}
 */
export function useFindProductionSiteRequestByUserForNonBrand<
  TData =
    ResponseConfig<FindProductionSiteRequestByUserForNonBrandQueryResponse>,
  TQueryData =
    ResponseConfig<FindProductionSiteRequestByUserForNonBrandQueryResponse>,
  TQueryKey extends QueryKey =
    FindProductionSiteRequestByUserForNonBrandQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductionSiteRequestByUserForNonBrandQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findProductionSiteRequestByUserForNonBrandQueryKey()

  const query = useQuery(
    {
      ...findProductionSiteRequestByUserForNonBrandQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
